// Central switches for features that exist end-to-end but are not ready for
// users yet. Typed as boolean (not literal) so linters don't treat guarded
// JSX as constant conditions.

// Customer interests are generated by ai-services and drive the product
// recommendations in campaign mails. The generated interests are not yet
// good enough to expose, so all interest UI (mailer and product detail) is
// hidden until quality is acceptable. Flip to true to bring the UI back.
export const AI_CUSTOMER_INTERESTS_ENABLED: boolean = false;
